import {
    ClassSpotsLeft,
    isInstanceSelected,
} from '~/components/forms/questions/scheduling/ClassDescription.jsx';
import { minutesToDuration } from '~/lib/DateTime.js';
import { truncate } from '~/lib/Utils.js';
import { CheckCircleIcon } from '@heroicons/react/24/solid/index.js';
import { useIsWaitlistEnabled } from '~/components/waitlist/AddToWaitlistModal.jsx';
import { clientFormatTime } from '~/public/lib/ClientDateTime.js';

const SingleClassBlock = ({
    instance,
    onClick,
    settings,
    selectedClasses,
    clientTz,
}) => {
    const hasImage = !!instance.event_type.image;
    const isWaitlistEnabled = useIsWaitlistEnabled(settings);

    const cannotBeBooked = instance.spots_left <= 0 && !isWaitlistEnabled;

    return (
        <div
            className={`text-sm flex flex-col justify-between border ${cannotBeBooked ? 'opacity-75' : ''} ${isInstanceSelected(instance, selectedClasses) ? 'themed-border' : 'border-transparent'} hover-themed-border rounded-lg mt-4 cursor-pointer`}
            onClick={onClick}
        >
            <div className="bg-white rounded-lg">
                {hasImage && (
                    <div>
                        <img
                            src={`/view-image/${instance.event_type.image}`}
                            alt={instance.event_type.name}
                            className="w-full h-24 object-cover rounded-t-lg"
                        />
                    </div>
                )}
                <div
                    className={`min-h-[80px] rounded-b-lg  ${hasImage ? '-mt-8 pb-3' : 'rounded-t-lg py-3'}`}
                >
                    <div
                        className={`${hasImage ? 'bg-gradient-fade-white-b-alt pt-4' : ''} px-2 flex justify-between mb-3 text-sm`}
                    >
                        <div className="font-medium mr-1">
                            {clientFormatTime(instance.start, clientTz)}
                        </div>
                        {!settings?.hideDuration && (
                            <div className="text-nowrap">
                                {minutesToDuration(
                                    instance.event_type.duration,
                                    true,
                                )}
                            </div>
                        )}
                    </div>
                    <div className="mb-3 px-2">
                        {truncate(instance.event_type.name, 30)}
                    </div>
                    <div className="flex items-end justify-between px-2">
                        <div>
                            <div className="text-gray-500">
                                {!settings?.hideBookableResource &&
                                    instance.bookable_resource?.name}
                            </div>
                            <ClassSpotsLeft
                                instance={instance}
                                settings={settings}
                                className="leading-tight"
                            />
                        </div>
                        {isInstanceSelected(instance, selectedClasses) && (
                            <CheckCircleIcon className="themed-text w-5 h-5" />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleClassBlock;
